// Shared helpers for the Institute Test Management module.
import React from 'react';

export const SUPER_ADMIN = 1;
export const CHAPTER_ADMIN = 2;

// Auth context pulled from sessionStorage (same keys the rest of the app uses).
export const authCtx = () => ({
  roleid: parseInt(sessionStorage.getItem('userroleId'), 10),
  chapterId: sessionStorage.getItem('userchapterId') || '',
  userId: sessionStorage.getItem('adminId') || '',
});

// Params every write call needs so the backend can apply role / chapter rules.
export const ctxParams = () => {
  const { roleid, chapterId, userId } = authCtx();
  return { roleid, chapterId, userId };
};

export const StatusBadge = ({ status }) => {
  const key = String(status || '').toLowerCase().replace(/\s+/g, '');
  const cls =
    key === 'pendingapproval' ? 'pending' :
    key === 'unregistered'    ? 'unregistered' :
    key || 'draft';
  return <span className={`inst-badge ${cls}`}>{status || '—'}</span>;
};

export const formatDateTime = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  let h = d.getHours();
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${p(d.getDate())}-${p(d.getMonth() + 1)}-${d.getFullYear()} ${h}:${p(d.getMinutes())} ${ampm}`;
};

export const formatDate = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}-${p(d.getMonth() + 1)}-${d.getFullYear()}`;
};

export const rupee = (v) =>
  v === null || v === undefined || v === '' ? '—' : `₹${Number(v).toLocaleString('en-IN')}`;

// datetime-local <input> wants "YYYY-MM-DDTHH:mm"
export const toLocalInput = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const toDateInput = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
